import { render, staticRenderFns } from "./FrsLoadingIndicator.vue?vue&type=template&id=64a1a99f&scoped=true&lang=html&"
import script from "./FrsLoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./FrsLoadingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./FrsLoadingIndicator.vue?vue&type=style&index=0&id=64a1a99f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1a99f",
  null
  
)

export default component.exports